<template>
  <div class="payment">
    <ion-row justify-content-center>
        <div class="payment-container">
            THANK YOU! WE WILL SEND YOU AN EMAIL FOR THE PAYMENT CONFIRMATION.
            <br/><ion-button @click="$router.push('/')">Done</ion-button>
        </div>
    </ion-row>
  </div>
</template>
<script>

import config from "../../config.js";
import { format } from "date-fns";

export default {
  data() {
    return {
      popupContent: false,
      plans: this.$config.plans
    }
  },

  methods: {
    async bankDeposit() {
      const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
      const doc = {
        type: this.$route.params.type,
        type_: this.plans[idx],
        payment: {
          type: 'bank_deposit',
          label: 'Bank Deposit',
          proof: {
            img: "",
            reference: "",
            date: ""
          }
        }
      };
      const res = await this.$http({
        method: "POST",
        url: config.api.url + "/subscribe",
        data: doc,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      //console.log(res);
    }
  },
  computed: {
    getExpiry() {
      const d = new Date;
      return format(d.setDate(d.getDate() + 7), "MMMM dd, yyyy")
    }
  },

  mounted() {
    // if(this.$route.params.type) {
    //   if(this.$route.params.type) {
    //     const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
    //     if(idx < 0) {
    //       this.$router.push('/subscribe');
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
  ion-button {
    color: #fff !important;
  }
  ion-icon[name="checkmark-circle"] {
    color: #18bc9c;
  }

  ion-icon[name="close-circle"] {
    color: #ff5858;
  }

  .payment table {
      min-width: 400px;
  }

  .payment table tbody tr td {
    vertical-align: top;
    padding-top: 10px;
  }

  .sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons ion-button {
    margin: 0.5em 0;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    color: #ffffff;
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .price-col {
    padding: 0 5px 0 1.5em;
    text-align: right;
  }

  @media (min-width: 770px) {
    .payment-container {
      width: 720px;
    }
  }
</style>
